import { setConsent } from 'firebase/analytics';
import { getServices } from '@breath-lab/services';
import type { CookieConsent } from '../../domain/cookieConsent';

/**
 * Thin proxy preserved for existing UI/page imports. The implementation lives
 * in `WebAnalyticsService` and is wired through the service container; pages
 * keep their `import { logEvent } from '@infra/firebase/analytics'` paths
 * during Phase 1 of the React Native port (services-extraction).
 */
export function logEvent(eventName: string, params?: Record<string, unknown>): Promise<void> {
  return getServices().analytics.logEvent(eventName, params);
}

export function setUserProperty(name: string, value: string): Promise<void> {
  return getServices().analytics.setUserProperty(name, value);
}

/**
 * Update GA4 Consent Mode analytics_storage to match the cookie choice.
 * 'all' grants persistent (cookie-backed) analytics; 'essential' and null stay
 * denied — Consent Mode still sends cookieless pings, so traffic-source
 * attribution survives without storing cookies. Boots the analytics instance so
 * the consent state and first session ping take effect immediately.
 */
export function applyAnalyticsConsent(consent: CookieConsent | null): void {
  setConsent({ analytics_storage: consent === 'all' ? 'granted' : 'denied' });
  // Touch the service so getAnalytics() initialises and the (cookieless or
  // granted) session ping fires even before the first logged event.
  void getServices().analytics.setUserProperty('consent_state', consent ?? 'unset');
}
